import {roRO} from '@mui/material/locale';
import {adminReportTranslationsRo} from 'modules/admin/report/translations/AdminReportTranslationsRo';
import {cropsTranslationsRo} from 'modules/crops/translations/CropsTranslationsRO';
import {fieldsTranslationsRo} from 'modules/fields/translations/FieldsTranslationsRo';
import {roReportTranslations} from 'modules/report/translations/RoReportTranslations';
import {soilsTranslationsRo} from 'modules/soils/translations/SoilsTranslationsRO';
import roMessages from '../locales/ro_RO.json';

const roLang = {
  messages: {
    ...roMessages,
    ...cropsTranslationsRo,
    ...soilsTranslationsRo,
    ...roReportTranslations,
    ...adminReportTranslationsRo,
    ...fieldsTranslationsRo,
  },
  muiLocale: roRO,
  locale: 'ro-RO',
};
export default roLang;
